export default "__VITE_ASSET__Cx4p2DT___"